export default __webpack_public_path__ + "static/media/garden-02.dbc5ec82.jpg";